import React from 'react';
import { Form, Card, Input, Button, message } from 'antd';
import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { useHistory } from 'react-router-dom';
import ProgressModal from '../../../components/ProgressModal';
import PageTitle from '../../../components/PageTitle';

const CHANGE_PASSWORD_MUTATION = gql`
  mutation ChangePasswordMutation($oldPassword: String!, $newPassword: String!) {
    changePassword(oldPassword: $oldPassword, newPassword: $newPassword) {
      id
    }
  }
`;

type FormType = {
  oldPassword: string,
  newPassword: string,
  confirm_password: string,
};

function ChangePassword() {
  const [form] = Form.useForm<FormType>();

  const [changePassword] = useMutation(CHANGE_PASSWORD_MUTATION, {
    onError: () => null,
    onCompleted: data => {
      ProgressModal.hide();

      message.success('修改成功');
      history.replace('/');
    },
  });
  const history = useHistory();

  let confirmPasswordDirty = false;

  const onChangePassword = (values: FormType) => {
    ProgressModal.show();

    changePassword({ variables: values });
  };

  const handleConfirmPasswordBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { value } = e.target;
    confirmPasswordDirty = confirmPasswordDirty || !!value;
  };

  return (
    <div className="ChangePassword">
      <PageTitle>修改密码</PageTitle>
      <Card bordered={false}>
        <Form form={form} layout="vertical" onFinish={onChangePassword} scrollToFirstError>
          <Form.Item
            label="旧密码"
            name="oldPassword"
            rules={[{ required: true, message: '必填' }]}
          >
            <Input.Password autoComplete="current-password" />
          </Form.Item>
          <Form.Item
            label="新密码"
            name="newPassword"
            dependencies={confirmPasswordDirty ? ['confirm_password'] : []}
            // validateTrigger="onBlur"
            rules={[
              { required: true, message: '必填' },
              {
                type: 'string',
                min: 6,
                message: '密码长度至少为6位',
              },
            ]}
          >
            <Input.Password autoComplete="new-password" />
          </Form.Item>

          <Form.Item
            label="确认密码"
            dependencies={['newPassword']}
            name="confirm_password"
            // validateTrigger="onBlur"
            rules={[
              { required: true, message: '请再次输入密码确认' },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject('两次输入的密码不一致');
                },
              }),
            ]}
          >
            <Input.Password autoComplete="new-password" onBlur={handleConfirmPasswordBlur} />
          </Form.Item>
          <Form.Item>
            <Button block type="primary" htmlType="submit">
              确认修改
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}

export default ChangePassword;
